import React, { useState } from 'react';
import { Modal, Row, Col, notification, } from 'antd';

import SalesOfficeSelect from '../common/SalesOfficeSelect';
import useSalesOffices from './../../hooks/useSalesOffices';

function SalesOfficeModal(props) {
    const { data }  = useSalesOffices();
    const [selectedSalesOffice, setSelectedSalesOfice] = useState([]);  

    const handleOk = () => {
        if (selectedSalesOffice.length === 0)
            return notification.info({ message: 'Oficina de ventas', description: 'Selecciona una oficina de ventas.', });
        props.onOk(data.find(x => x.id === selectedSalesOffice));
    };

    return <Modal title="Oficina de ventas"
        open={props.visible}
        onOk={handleOk}
        okText="Tomar"
        cancelText="Cancelar"
        centered={true}
        closable={false}
        cancelButtonProps={{
            style: { display: 'none' }
        }}
    >
        <Row>
            <Col span={24}>
                <SalesOfficeSelect 
                    style={{ width: '100%' }}
                    onChange={(value) => setSelectedSalesOfice(value)}
                    placeholder="Oficina de ventas..."
                    maxTagCount="responsive"
                    onlyOwnedByCurrentUser
                />
            </Col>
        </Row>
    </Modal>
}

export default SalesOfficeModal;